import React, { useState, useRef } from 'react';
import Button from "react-bootstrap/Button";
import Input from "../../../components/forms-fields/Input";
import { addMedicineList } from "../../../schemas";
import { useFormik } from "formik";
import Select from 'react-select';
import TextArea from '../../../components/forms-fields/TextArea';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { POST_MEDICINE_STOCK_URL } from "../../../env";
import {
  postRecords,
  catchAsync,
  isSuccess,
  toastSuccessMessages,
  toastErrorMessages,
} from "../../../helper/helper";


import Layout from '../../../components/layouts/Layout';
import { Link } from 'react-router-dom';
import moment from 'moment';
import MedicationStocksDetail from '../../../components/forms-fields/MedicationStocksDetail';
import MedicineListDetail from '../../../components/forms-fields/MedicineListDetail';


function AddMedicaitonOverviewList({ userId, subModalAddMedicine }) {
  const storedUserDetails = localStorage.getItem("profileUserDetails");
  const userDetails = JSON.parse(storedUserDetails);
  // console.log("🚀 ~ AddMedicaitonOverviewList ~ userDetails:", userDetails)
  const handleShowHideModal = () => {
    subModalAddMedicine((prevShow) => !prevShow);
  };
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const [isToastAddMedicine, setIsToastAddMedicine] = useState(false);

  const [suFormData, setSuFormData] = useState({
    medicationName: "",
    medicineType: "",
    strength: "",
    unitType: "",
    sideEffect: "",
    medicationSafetyTime: 0,
    description: "",

  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: suFormData,
    validationSchema: addMedicineList,
    onSubmit: async (values) => {
      try {

        setIsSubmitButtonClicked(true);
        await postAddMedicineFormData(values);
      } catch (error) {

      }
    },
  });

  const processPostRecords = (method, data) => {

    if (data?.status !== isSuccess) {
      setIsToastAddMedicine(true);
      toastErrorMessages(toast.error, data?.message, "", 500, 500);
      setIsSubmitButtonClicked(false);
      handleShowHideModal();
    } else if (
      method === "postAddMedicineFormData" &&
      data?.status === isSuccess
    ) {
      setIsToastAddMedicine(true);
      toastSuccessMessages(toast.success, data?.message, "/medication-overview", 500, 500);
      setIsSubmitButtonClicked(false);
      // setTimeout(() => {
      //   handleShowHideModal();
      // }, 2000);
    }
  };

  const postAddMedicineFormData = catchAsync(async (req, res) => {
    // console.log("🚀 ~ postAddMedicineFormData ~ values:", values)
    const response = await postRecords(POST_MEDICINE_STOCK_URL, values);
    // console.log("🚀 ~ postAddMedicineFormData ~ response:", response)
    processPostRecords("postAddMedicineFormData", response);
    setIsSubmitButtonClicked(false);
  });



  const handleMedicineType = (e) => {
    if (e && e?.value !== undefined) {
      setFieldValue("medicineType", e.value);
    }
  };
  const handleUnitType = (e) => {
    if (e && e?.value !== undefined) {
      setFieldValue("unitType", e.value);
    }
    else {
      handleChange(e);
      handleBlur(e);
    }
  };
  const medicineTypeOptions = [
    { label: 'Controlled Drug', value: 'Controlled Drug' },
    { label: 'Regular Medication', value: 'Regular Medication' },
    { label: 'Topical Medication', value: 'Topical Medication' },
  ];
  const unitTypeOptions = [
    { label: 'Capsules', value: 'Capsules' },
    { label: 'Chewable Tablet', value: 'Chewable Tablet' },
    { label: 'Dispersible Tablet', value: 'Dispersible Tablet' },
    { label: 'Ear Drops', value: 'Ear Drops' },
    { label: 'Eye Drops', value: 'Eye Drops' },
    { label: 'Inhaler', value: 'Inhaler' },
    { label: 'Injection', value: 'Injection' },
    { label: 'Oral Suspension (liquid)', value: 'Oral Suspension (liquid)' },
    { label: 'Patch', value: 'Patch' },
    { label: 'Sachet', value: 'Sachet' },
    { label: 'Spray', value: 'Spray' },
    { label: 'Suppository', value: 'Suppository' },
    { label: 'Tablets', value: 'Tablets' },
    { label: 'Topical (Cream)', value: 'Topical (Cream)' },
    // Add more options as needed
  ];



  const [selectedMedication, setSelectedMedication] = useState("Medication not selected");
  const [medicationData, setMedicationData] = useState([]);
  const handleMedicationSelect = (value) => {
    setSelectedMedication(value);
    setFieldValue("medicationName", value)
  };


  const handleMedicationDataChange = (data) => {
    setMedicationData(data);
    setFieldValue("medicationName", medicationData?.medicationName)
  };

  return (
    <>
      <Layout
        pageTitleText={
          <>
            Medicine List
          </>
        }
      >
        <div className="incidents consentCapacityAddNew">
          <div className="mainContent">
            <div className="mainContentText">
              <h3>Add New Medicine</h3>
              <form onSubmit={handleSubmit}>
                <div className="formBlockContent">
                  <div className="row">
                    <div className="col-sm-6 col-md-4">
                      <div className="form-group">
                        <MedicineListDetail
                          label={"Medicine Name"}
                          requiredStar={true}
                          name={"medicationName"}
                          onSelect={handleMedicationSelect}
                          onMedicationDataChange={handleMedicationDataChange}
                          customError={
                            errors.medicationName && touched.medicationName
                          }
                          errorMessage={errors.medicationName}
                          errorClass={
                            errors.medicationName && touched.medicationName
                          } />

                      </div>
                    </div>
                    <div className="col-md-4">
                      <Input
                        type="text"
                        id="strength"
                        name="strength"
                        value={values?.strength}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        labelText="Strength"
                        customError={touched?.strength && errors?.strength}
                        errorMessage={errors?.strength}
                        erroClass={
                          touched?.strength && errors?.strength
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />
                    </div>
                    <div className="col-md-4">
                      <Input
                        type="text"
                        id="sideEffect"
                        name="sideEffect"
                        value={values?.sideEffect}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        labelText="Side Effects"
                        customError={touched?.sideEffect && errors?.sideEffect}
                        errorMessage={errors?.sideEffect}
                        erroClass={
                          touched?.sideEffect && errors?.sideEffect
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />
                    </div>
                    <div className="col-md-4">
                      <div className="customSelectBox">
                        <div className={`form-group ${(errors.unitType && touched.unitType) ? "validationError" : null}`}>
                          <Select
                            name="unitType"
                            options={unitTypeOptions}
                            onChange={handleUnitType}
                            onBlur={handleBlur}
                            value={unitTypeOptions.find(unitTypeOptions => unitTypeOptions.value === values?.unitType)}

                          />
                          <label className="floatingLabel">Unit Type<span className="text-danger">*</span></label>
                          {/* Display error message if touched and has an error */}
                          {touched.unitType && errors.unitType && (
                            <div className="text-danger">{errors.unitType}</div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="customSelectBox">
                        <div className={`form-group ${(errors.medicineType && touched.medicineType) ? "validationError" : null}`}>
                          <Select
                            name="medicineType"
                            options={medicineTypeOptions}
                            onChange={handleMedicineType}
                            onBlur={handleBlur}
                            value={medicineTypeOptions.find(medicineTypeOptions => medicineTypeOptions.value === values?.medicineType)}

                          />
                          <label className="floatingLabel">Medicine Type <span className="text-danger">*</span></label>
                          {/* Display error message if touched and has an error */}
                          {touched.medicineType && errors.medicineType && (
                            <div className="text-danger">{errors.medicineType}</div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <Input
                        type="text"
                        id="medicationSafetyTime"
                        name="medicationSafetyTime"
                        value={values?.medicationSafetyTime}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        labelText="Safety Time"
                        customError={touched?.medicationSafetyTime && errors?.medicationSafetyTime}
                        errorMessage={errors?.medicationSafetyTime}
                        erroClass={
                          touched?.medicationSafetyTime && errors?.medicationSafetyTime
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />
                    </div>
                    <div className="col-md-12">

                      <TextArea
                        id="description"
                        name="description"
                        value={values?.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        labelText="Description"
                        rows="3"
                        className="mb-0"
                        customError={touched?.description && errors?.description}
                        errorMessage={errors?.description}
                        erroClass={
                          touched?.description && errors?.description
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />
                    </div>

                  </div>
                </div>
                <div className="formActionButtons mt-5">
                  <Link to="/medication-overview">
                    <span
                      className="btn btn-sm btn-outline-primary"
                    >
                      Cancel
                    </span>
                  </Link>
                  {isSubmitButtonClicked ? (
                    <Button
                      className="btn-sm"
                      variant="primary"
                      disabled
                    >
                      Loading...
                    </Button>
                  ) : (
                    <Button className="btn-sm" variant="primary" type="submit">
                      Save
                    </Button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </Layout>
      {isToastAddMedicine && <ToastContainer />}
    </>
  );
}

export default AddMedicaitonOverviewList